// extracted by mini-css-extract-plugin
module.exports = {"demoContainer":"Profile_demoContainer__2Jqz3","demoInput":"Profile_demoInput__3NIu5","demoLabel":"Profile_demoLabel__2rRDx"};